import api from "../axiosInstance";

// User Management API client
export async function getAllUsers(params = {}) {
  const {
    searchTerm,
    active,
    role,
    page = 0,
    size = 10,
    sortBy = "id",
    sortDirection = "asc"
  } = params;

  const queryParams = new URLSearchParams();
  if (searchTerm) queryParams.append('searchTerm', searchTerm);
  if (active !== undefined) queryParams.append('active', active);
  if (role) queryParams.append('role', role);
  queryParams.append('page', page);
  queryParams.append('size', size);
  queryParams.append('sortBy', sortBy);
  queryParams.append('sortDirection', sortDirection);

  const resp = await api.get(`/api/admin/management/users?${queryParams.toString()}`);
  return resp.data;
}

export async function getUserById(id) {
  const resp = await api.get(`/api/admin/management/users/${id}`);
  return resp.data;
}

export async function getUserByEmail(email) {
  const resp = await api.get(`/api/admin/management/users/email/${encodeURIComponent(email)}`);
  return resp.data;
}

export async function updateUser(id, userData) {
  const resp = await api.put(`/api/admin/management/users/${id}`, userData);
  return resp.data;
}

export async function deleteUser(id) {
  const resp = await api.delete(`/api/admin/management/users/${id}`);
  return resp.data;
}

export async function activateUser(id) {
  const resp = await api.post(`/api/admin/management/users/${id}/activate`);
  return resp.data;
}

export async function deactivateUser(id) {
  const resp = await api.post(`/api/admin/management/users/${id}/deactivate`);
  return resp.data;
}

export async function assignRolesToUser(id, roles) {
  const resp = await api.put(`/api/admin/management/users/${id}/roles`, { roles });
  return resp.data;
}

export async function addRoleToUser(id, roleName) {
  const resp = await api.post(`/api/admin/management/users/${id}/roles/${encodeURIComponent(roleName)}`);
  return resp.data;
}

export async function removeRoleFromUser(id, roleName) {
  const resp = await api.delete(`/api/admin/management/users/${id}/roles/${encodeURIComponent(roleName)}`);
  return resp.data;
}

export async function createUser(userData) {
  // Spec implies admin management create; using base collection POST
  const resp = await api.post(`/api/admin/management/users`, userData);
  return resp.data;
}